<div class="toasts">
  @if (toastService.toasts().length > 1) {
    <button
      (click)="toastService.removeAllToasts()"
      hlmBtn class="remove-all-toasts-btn w-full"
      type="button">Убрать все
    </button>
  }

  @for (t of toastService.newestFirst(); track t.id) {
    <div (click)="removeToast(t.id ?? 0)"
      [ngClass]="tTypes[t.type].toLowerCase()"
      class="toast">
      <div class="head">
        <div class="title">{{t.title}}</div>
        <div class="remove-toast">
          <svg style="fill: rebeccapurple"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <path
            d="M9.172 16.242 12 13.414l2.828 2.828 1.414-1.414L13.414 12l2.828-2.828-1.414-1.414L12 10.586 9.172 7.758 7.758 9.172 10.586 12l-2.828 2.828z"></path>
            <path
            d="M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10zm0-18c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8z"></path>
          </svg>
        </div>
      </div>
      <div class="message">{{t.message}}</div>
    </div>
  }
</div>
